import { render, staticRenderFns } from "./ProjectJurnalTable.vue?vue&type=template&id=4e550a2d&scoped=true"
import script from "./ProjectJurnalTable.vue?vue&type=script&lang=js"
export * from "./ProjectJurnalTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectJurnalTable.vue?vue&type=style&index=0&id=4e550a2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e550a2d",
  null
  
)

export default component.exports